import {
  QueryStringMetadataOptionFromFilter,
  QueryStringNonMetadataOptionFromFilter,
} from '@modules/common/types';
import { NestedQueryStringOptions } from './transformWhereClauseToFieldNameValues';

export const isQueryStringOptionFromFilter = (
  item:
    | QueryStringNonMetadataOptionFromFilter
    | QueryStringMetadataOptionFromFilter
    | NestedQueryStringOptions,
): item is
  | QueryStringNonMetadataOptionFromFilter
  | QueryStringMetadataOptionFromFilter => {
  return !!item.fieldName;
};
